module.exports = __webpack_public_path__ + "img/item11.454adf1b.png";